/// <reference path="../../_Ext/Editors/DetailEditorDialog.ts" />
namespace TabAurous.Retail {
    export var amount: number = 0;

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.maximizable(false)
    export class POSSalesReceiptDialog extends _Ext.DetailEditorDialog<POSSalesReceiptRow> {
        protected getFormKey() { return POSSalesReceiptForm.formKey; }
        protected getLocalTextPrefix() { return POSSalesReceiptRow.localTextPrefix; }

        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }

        protected form = new POSSalesReceiptForm(this.idPrefix);
        constructor() {
            super();

            q.setTextRightAlign(this.form.Amount);
            q.setTextRightAlign(this.form.Total);
            q.setTextRightAlign(this.form.Balance);
            q.hideEditorLabel(this.form.Denominations);
            q.hideEditorToolbar(this.form.Denominations);
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 350;
            q.initSubDetailsEditor(this, this.form.Denominations, Config);
            this.form.ModeId.changeSelect2(e => {
                var ledger = OMS.PaymentModeRow.getLookup().itemById[this.form.ModeId.value];
                this.form.LedgerId.value = ledger.LedgerId.toString();

                Serenity.EditorUtils.setReadOnly(this.form.LedgerId, true);
                if (ledger.Type == 280) { //For Cash
                    Serenity.EditorUtils.setReadOnly(this.form.Amount, true); 
                    q.hideField(this.form.ChequeDate, true);
                    q.hideField(this.form.ChequeNo, true);
                    q.hideField(this.form.Scheme, true);
                    q.hideField(this.form.RefNo, true);
                    q.hideField(this.form.BankId, true);
                    q.showField(this.form.Denominations);
                    this.form.Denominations.setData();
                }
                else if (ledger.Type == 283) { //For Gift Voucher
                    Serenity.EditorUtils.setReadOnly(this.form.Amount, true);
                    q.hideField(this.form.ChequeDate, true);
                    q.hideField(this.form.ChequeNo, true);
                    q.hideField(this.form.Scheme, true);
                    q.hideField(this.form.BankId, true);
                    q.hideField(this.form.RefNo, false);
                    q.hideField(this.form.Denominations);
                }
                else if (ledger.Type == 281) {//For Cheque
                    Serenity.EditorUtils.setReadOnly(this.form.Amount, false);
                    q.hideField(this.form.ChequeDate, false);
                    q.hideField(this.form.ChequeNo, false);
                    q.hideField(this.form.BankId, false);


                    q.hideField(this.form.Scheme, true);
                    q.hideField(this.form.RefNo, true);
                    q.hideField(this.form.Denominations);
                }
                else if (ledger.Type == 284) {//For Scheme Voucher
                    Serenity.EditorUtils.setReadOnly(this.form.Amount, true);
                    q.hideField(this.form.ChequeDate, true);
                    q.hideField(this.form.ChequeNo, true);
                    q.hideField(this.form.BankId, true);
                    q.hideField(this.form.Scheme, false);
                    q.hideField(this.form.RefNo, true);
                    q.hideField(this.form.Denominations);
                    this.form.Scheme.cascadeField = "CustomerId";
                    var customerid = parseInt((this.parentEditor.parentDialog as POSSalesDialog).form.POSCustomerId.value)
                    // **** Validate Party before Item Selection ****
                    if (customerid == 0 || customerid == null) {
                        Q.alert('Please Select Customer');
                        this.dialogClose();
                    }
                }
                this.form.RefNo.value = "";
                this.form.Scheme.value = "";

            });
            this.form.RefNo.changeSelect2(e => {
                var details = GiftVoucherItemDetailsRow.getLookup().items.filter(x => x.UniqueNo == this.form.RefNo.value);
                amount = 0;
                for (var i = 0; i < details.length; i++) {
                    amount += details[i].Amount;
                }
                this.form.Amount.value = amount;
                if (details[0].IsPartial) {

                    Serenity.EditorUtils.setReadOnly(this.form.Amount, false);
                } else { Serenity.EditorUtils.setReadOnly(this.form.Amount, false); }
            });
            this.form.Amount.changeSelect2(e => {
                if (this.form.ModeId.value == "283") {
                    if (this.form.Amount.value > amount) {
                        Q.alert('Gift Voucher Limit Exceded');
                        this.form.Amount.value = amount;
                        return;
                    }
                }
                this.calculateBalance();
            });
            this.form.Scheme.changeSelect2(e => {
                //var schemedetails = Scheme.SchemeEnrollmentRow.getLookup().itemById[this.form.Scheme.value];
                var totalamount = 0;

                Scheme.SchemeMasterService.Retrieve({
                    EntityId: parseInt(this.form.Scheme.value)
                }, response => {
                    totalamount = response.Entity.SchemeAmount + response.Entity.BonusValue;
                }, { async: false });

                this.form.Amount.value = totalamount;
            });
        }
        protected onDialogOpen() {
            super.onDialogOpen();
            var balanceamount = (this.parentEditor.parentDialog as POSSalesDialog).form.BalanceAmount.value;
            if (balanceamount == null || balanceamount == 0) {
                this.dialogClose();
                q.Alert('', 'No Balance left for New Receipts', 2999, true);                
                return;
            }
            q.hideField(this.form.Denominations);

            if (this.form.ModeId.value != "") {
                var ledger = OMS.PaymentModeRow.getLookup().itemById[this.form.ModeId.value];
                if (ledger.Type == 283) {
                    var details = GiftVoucherItemDetailsRow.getLookup().items.filter(x => x.UniqueNo == this.form.RefNo.value);
                    amount = 0;
                    for (var i = 0; i < details.length; i++) {
                        amount += details[i].Amount;
                    }
                    q.hideField(this.form.Denominations);
                }
                else if (ledger.Type == 283) {
                    q.hideField(this.form.Scheme, false);
                    q.hideField(this.form.Denominations);
                }

                if (ledger.Type == 280) { //For Cash
                    Serenity.EditorUtils.setReadOnly(this.form.Amount, false);
                    q.hideField(this.form.ChequeDate, true);
                    q.hideField(this.form.ChequeNo, true);
                    q.hideField(this.form.BankId, true);
                    q.hideField(this.form.Scheme, true);
                    q.hideField(this.form.RefNo, true);
                    q.showField(this.form.Denominations);

                }
                else if (ledger.Type == 283) { //For Gift Voucher
                    Serenity.EditorUtils.setReadOnly(this.form.Amount, true);
                    q.hideField(this.form.ChequeDate, true);
                    q.hideField(this.form.ChequeNo, true);
                    q.hideField(this.form.Scheme, true);
                    q.hideField(this.form.BankId, true);
                    q.hideField(this.form.RefNo, false);
                    q.hideField(this.form.Denominations);
                }
                else if (ledger.Type == 281) {//For Cheque
                    Serenity.EditorUtils.setReadOnly(this.form.Amount, false);
                    q.hideField(this.form.ChequeDate, false);
                    q.hideField(this.form.ChequeNo, false);
                    q.hideField(this.form.BankId, false);
                    q.hideField(this.form.Scheme, true);
                    q.hideField(this.form.RefNo, true);
                    q.hideField(this.form.Denominations);
                }
                else if (ledger.Type == 284) {//For Scheme Voucher
                    Serenity.EditorUtils.setReadOnly(this.form.Amount, true);
                    q.hideField(this.form.ChequeDate, true);
                    q.hideField(this.form.ChequeNo, true);
                    q.hideField(this.form.BankId, true);
                    q.hideField(this.form.Scheme, false);
                    q.hideField(this.form.RefNo, true);
                    this.form.Scheme.cascadeField = "CustomerId";
                    var customerid = parseInt((this.parentEditor.parentDialog as POSSalesDialog).form.POSCustomerId.value)
                    // **** Validate Party before Item Selection ****
                    if (customerid == 0 || customerid == null) {
                        Q.alert('Please Select Customer');
                        this.dialogClose();
                    }
                    q.hideField(this.form.Denominations);
                }

                if (this.form.ModeId.value == "18") {
                    q.showAndDisableField(this.form.ModeId);
                    q.showAndDisableField(this.form.Amount);
                    q.hideField(this.form.BankId);
                    q.hideField(this.form.ChequeDate);
                    q.hideField(this.form.ChequeNo);
                    q.hideField(this.form.Scheme);
                    q.hideField(this.form.RefNo);
                } else
                    this.form.ModeId.items = this.form.ModeId.items.filter(x => x.id != "18");

            } else {
                q.hideField(this.form.Scheme, true);
                q.hideField(this.form.ChequeNo, true);
                q.hideField(this.form.ChequeDate, true);
                q.hideField(this.form.BankId, true);
                this.form.ModeId.items = this.form.ModeId.items.filter(x => x.id != "18");
            }

        }

        protected afterLoadEntity() {
            super.afterLoadEntity();
            var balanceamount = (this.parentEditor.parentDialog as POSSalesDialog).form.BalanceAmount.value;
            if (balanceamount == null || balanceamount == 0) {
                q.Alert('', 'No Balance left for New Receipts', 2999, true);
                this.dialogClose();
                return;
            }

            if (this.form.ModeId.value == "") {
                this.form.ModeId.value = "";
                this.form.Amount.value = 0.00;
                this.form.ChequeDate.value = "";
                this.form.ChequeNo.value = 0;
                this.form.RefNo.value = "";
            }
            this.form.Total.value = (this.parentEditor.parentDialog as POSSalesDialog).form.GrossAmount.value;
            this.form.Balance.value = (this.parentEditor.parentDialog as POSSalesDialog).form.BalanceAmount.value;

            this.form.TempAmount.value = this.form.Amount.value;

        }
        
        setAmount() {
            var denominations = this.form.Denominations.getItems();
            var amount = 0;
            for (var i = 0; i < denominations.length; i++) {
                if (denominations[i].Amount != null)
                    amount += denominations[i].Count * denominations[i].Code;
            }
            this.form.Amount.value = amount;
            this.calculateBalance();
        }
        calculateBalance() {
            var grossamount = (this.parentEditor.parentDialog as POSSalesDialog).form.GrossAmount.value;
            var receiptamount = (this.parentEditor.parentDialog as POSSalesDialog).form.Receipt.value;
            receiptamount -= this.form.TempAmount.value;
            var amount = this.form.Amount.value;
            //var oldamount = this.form.TempAmount.value;
            this.form.Balance.value = grossamount - (amount + receiptamount);
        }
        validateBeforeSave() {
            var returnvalue = super.validateBeforeSave();
            //var amount = this.form.Amount.value;
            //var balance = this.form.Balance.value;
            //if (amount > balance) {
            //    q.Alert('', 'Amount cannot be greater than Balance', 2999, true);
            //    returnvalue = false;
            //    return returnvalue;
            //}
            if (returnvalue) {
                var ledger = OMS.PaymentModeRow.getLookup().itemById[this.form.ModeId.value];
                if (ledger.Type == 280) {
                    var denominations = this.form.Denominations.getItems();

                    for (var i = 0; i < denominations.length; i++) {
                        if (denominations[i].Amount == null) {
                            denominations[i].Amount = 0;
                            denominations[i].Count = 0;
                        }
                    }
                }
            }
            return returnvalue;
        }
    }
}